import {
  INTERACTIVE_TARGET_SELECTOR,
  QUICK_FILTER_COLUMN_ATTR,
} from '../../constants';
import { isPrintableTriggerKey } from './isPrintableTriggerKey';

// Returns true when the keydown should open the sorted column's filter — printable key, grid mounted, focus not on an interactive control. The filter menu button itself is allowed because it keeps focus after Esc closes the overlay.
export const canOpenSortedColumnFilter = (
  event: KeyboardEvent,
  gridElement: HTMLElement | null
): boolean => {
  if (!isPrintableTriggerKey(event)) return false;
  if (!gridElement || !document.body.contains(gridElement)) return false;

  const target = event.target as HTMLElement | null;
  const interactive = target?.closest(INTERACTIVE_TARGET_SELECTOR);
  if (interactive && !interactive.hasAttribute(QUICK_FILTER_COLUMN_ATTR)) {
    return false;
  }
  if (target?.getAttribute('role') === 'textbox') return false;

  return true;
};
